module.exports = __webpack_public_path__ + "static/img/7.72021c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/zh/7.png
// module id = xe4T
// module chunks = 0